/* ================================================================
   LILIMAUS Empfehlungs-Engine (CRO Welle 3, Stand 2026-09-10)
   ----------------------------------------------------------------
   Fuellt zwei Container mit "Passt perfekt dazu"-Karten
   (Bild links, Titel/Farbe/Preis inkl. MwSt., runder Plus-Button —
   Layout-Vorlage: Marc-Screenshot 07.07.):

   1) [data-lm-cross-sell]      im Warenkorb-Drawer (Kontextfarben =
                                Farben der Warenkorb-Artikel)
   2) [data-lm-complementary]   auf der PDP (Kontextfarbe = aktuell
                                gewaehlte Variante, via data-color)

   Datenquelle: /recommendations/products.json intent=complementary
   (gepflegt aus der Ko-Kauf-Analyse; Fallback intent=related).

   HARTE FARB-REGEL (Marc 07.07.): Hat ein empfohlenes Produkt eine
   Farboption, aber KEINE verfuegbare Variante in einer Kontextfarbe
   (Kombi-Farben wie "Eukalyptus & Hellbeige" zaehlen als Treffer),
   wird es komplett ausgeblendet — kein Farb-Fallback. Produkte ohne
   Farboption (z. B. Leuchtsterne) bleiben zugelassen.

   Drawer + PDP-Section werden bei Aenderungen server-seitig neu
   gerendert (innerHTML-Replace) -> Body-MutationObserver findet
   frische, noch nicht hydratisierte Container und fuellt sie neu
   (so folgt die PDP-Empfehlung auch dem Farbwechsel der Variante).
   ================================================================ */
(function () {
  'use strict';

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* ---------------- Empfehlungen ---------------- */

  /* Vorbestell-Varianten NICHT empfehlen (Marc 2026-09-10). Befund: Der Plus-
     Button legte Vorbestell-Varianten ohne Hinweis und ohne Checkout-Merkmal
     "Vorbestellung" in den Warenkorb (43 Bestellungen im WMS ohne Kennzeichnung).
     Das oeffentliche Varianten-JSON kennt Policy/Bestand nicht; deshalb liefert
     sections/lm-preorder-ids.liquid je Produkt die Vorbestell-IDs serverseitig
     (Regel wie snippets/product-variant-picker.liquid). Diese Varianten gelten
     hier als nicht verfuegbar -> Farbregel/pickVariant blenden sie aus.
     Fail-open: ohne Antwort bleibt das bisherige Verhalten. */
  var preorderCache = {};
  function preorderIdsFor(handle) {
    if (!handle) return Promise.resolve([]);
    if (!preorderCache[handle]) {
      preorderCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=lm-preorder-ids')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/data-lm-preorder-ids="([^"]*)"/);
          return m ? m[1].split(',').filter(Boolean) : [];
        })
        .catch(function () { return []; });
    }
    return preorderCache[handle];
  }
  function ohneVorbestellVarianten(products) {
    return Promise.all((products || []).map(function (p) {
      return preorderIdsFor(p.handle).then(function (ids) {
        if (ids.length) {
          (p.variants || []).forEach(function (v) {
            if (ids.indexOf(String(v.id)) !== -1) v.available = false;
          });
        }
        return p;
      });
    }));
  }

  function fetchRecommendations(productId) {
    var base = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10';
    return fetch(base + '&intent=complementary')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        if (d.products && d.products.length) return d.products;
        return fetch(base + '&intent=related')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d2) { return d2.products || []; });
      })
      .then(ohneVorbestellVarianten)
      .catch(function () { return []; });
  }

  function colorOptionIndex(product) {
    var idx = -1;
    (product.options || []).forEach(function (o, i) {
      var name = typeof o === 'string' ? o : (o && o.name);
      if (name && name.toLowerCase() === 'farbe') idx = i;
    });
    return idx;
  }

  function normColor(s) {
    return (s || '').toLowerCase().trim();
  }

  // Kombi-Farben ("Eukalyptus & Hellbeige") passen zur Einzelfarbe "Eukalyptus".
  // Rang: 3 = exakt, 2 = Kombi beginnt mit der Farbe, 1 = Kombi enthaelt die Farbe.
  function colorMatchRank(variantColor, contextColor) {
    var v = normColor(variantColor);
    var c = normColor(contextColor);
    if (!v || !c) return 0;
    if (v === c) return 3;
    var parts = v.split('&').map(function (x) { return x.trim(); });
    if (parts.length > 1) {
      if (parts[0] === c) return 2;
      if (parts.indexOf(c) !== -1) return 1;
    }
    return 0;
  }

  // Strikt: Produkt mit Farboption + Kontextfarben vorhanden -> nur bei Match,
  // sonst null (Produkt wird nicht angezeigt). Ohne Farboption/Kontextfarben:
  // erste verfuegbare Variante.
  function pickVariant(product, contextColors) {
    var idx = colorOptionIndex(product);
    if (idx >= 0 && contextColors.length) {
      var best = null, bestScore = 0;
      (product.variants || []).forEach(function (v) {
        if (!v.available) return;
        for (var c = 0; c < contextColors.length; c++) {
          var rank = colorMatchRank(v['option' + (idx + 1)], contextColors[c]);
          var score = rank * 10 - c;
          if (rank > 0 && score > bestScore) {
            bestScore = score;
            best = { variant: v, color: v['option' + (idx + 1)] };
          }
        }
      });
      return best; // null = keine passende Farbe -> ausblenden
    }
    var first = (product.variants || []).find(function (v) { return v.available; });
    return first ? { variant: first, color: null } : null;
  }

  function imageUrl(product, variant) {
    var src = (variant.featured_image && variant.featured_image.src) || product.featured_image || '';
    if (!src) return '';
    return src.indexOf('?') === -1 ? src + '?width=160' : src + '&width=160';
  }

  function cardHtml(product, pick, compact) {
    var v = pick.variant;
    // Sparsets (Platzhalter-Produkt mit EINER Default-Variante ohne SKU) duerfen nie
    // direkt in den Warenkorb: nur der Set-Builder auf der Set-Seite legt die
    // Komponenten-SKUs ab. Fall #16045 (21.08.26): "+" auf der Baldachin-PDP legte
    // den Platzhalter "Kuschelecke" ohne Farbe/SKU in den Korb -> nicht lieferbar.
    // Karte bleibt (Ansage Marc 30.07.: Sets auf der PDP erlaubt), Knopf wird Link.
    var isSet = isSparsetProduct(product);
    var setUrl = product.url || ('/products/' + product.handle);
    function actionHtml(size, font, lineH) {
      var base = 'width:' + size + 'px;height:' + size + 'px;border-radius:50%;background:#111;color:#fff;border:none;' +
        'font-size:' + font + 'px;line-height:' + lineH + 'px;text-align:center;padding:0;cursor:pointer;flex-shrink:0;';
      if (isSet) {
        return '<a href="' + escapeHtml(setUrl) + '" aria-label="' + escapeHtml(product.title) + ' ansehen und Farben wählen" ' +
          'style="' + base + 'display:inline-block;text-decoration:none;">&rarr;</a>';
      }
      return '<button type="button" data-lm-add="' + v.id + '" aria-label="' + escapeHtml(product.title) + ' in den Warenkorb" ' +
        'style="' + base + '">+</button>';
    }
    // Sets: keine Preisangabe auf der Karte (Set-Preis entsteht erst aus der Farb-/
    // Optionswahl im Builder; der Platzhalter-Preis ist keine belastbare "ab"-Angabe).
    var subline = isSet ? 'Set · Farben frei wählbar · Preis auf der Set-Seite' : pick.color;
    if (compact) {
      // Schlanke Karte fuer den Warenkorb-Drawer: 1 Zeile Titel, Farbe+Preis
      // kombiniert, kleineres Bild/Button -> mehr Platz fuer die Warenkorb-Artikel.
      return (
        '<div style="display:flex;align-items:center;gap:10px;background:#fff;border:1px solid #ececec;border-radius:10px;padding:6px 8px;">' +
          '<img src="' + escapeHtml(imageUrl(product, v)) + '" alt="" loading="lazy" width="44" height="44" style="width:44px;height:44px;object-fit:cover;border-radius:6px;flex-shrink:0;">' +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-size:12px;font-weight:600;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(product.title) + '</div>' +
            '<div style="font-size:11px;color:#888;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + (isSet ? escapeHtml(subline) : (subline ? escapeHtml(subline) + ' · ' : '') + '<span style="color:#111;font-weight:600;">' + money(v.price) + '</span>') + '</div>' +
          '</div>' +
          actionHtml(32, 18, 30) +
        '</div>'
      );
    }
    return (
      '<div style="display:flex;align-items:center;gap:12px;background:#fff;border:1px solid #ececec;border-radius:12px;padding:10px 12px;">' +
        '<img src="' + escapeHtml(imageUrl(product, v)) + '" alt="" loading="lazy" width="72" height="72" style="width:72px;height:72px;object-fit:cover;border-radius:8px;flex-shrink:0;">' +
        '<div style="flex:1;min-width:0;">' +
          '<div style="font-size:13px;font-weight:600;line-height:1.35;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;">' + escapeHtml(product.title) + '</div>' +
          (subline ? '<div style="font-size:12px;color:#888;margin-top:1px;">' + escapeHtml(subline) + '</div>' : '') +
          (isSet ? '' : '<div style="margin-top:3px;"><span style="font-size:14px;font-weight:700;">' + money(v.price) + '</span>' +
          ' <span style="font-size:11px;color:#999;">inkl. MwSt.</span></div>') +
        '</div>' +
        actionHtml(40, 22, 38) +
      '</div>'
    );
  }

  // Sparsets/Set-Konfigurator gehoeren NICHT in den Warenkorb-Upsell (Ansage Marc
  // 30.07.26): wer schon Einzelteile im Korb hat, soll dort kein konkurrierendes
  // Komplett-Set angeboten bekommen. Auf der PDP bleiben sie erlaubt.
  // Erkennung ueber den Handle — /recommendations/products.json liefert weder
  // template_suffix noch (bei LILIMAUS) belastbare Tags/Types mit.
  function isSparsetProduct(product) {
    var handle = (product && product.handle) || '';
    return handle.indexOf('sparset-') === 0 || handle === 'erstelle-dein-set';
  }

  function buildCards(products, contextColors, excludeIds, limit, compact) {
    var cards = [];
    for (var i = 0; i < products.length && cards.length < limit; i++) {
      var p = products[i];
      if (!p.available || excludeIds.indexOf(String(p.id)) !== -1) continue;
      var pick = pickVariant(p, contextColors);
      if (!pick) continue;
      cards.push(cardHtml(p, pick, compact));
    }
    return cards;
  }

  /* ---------------- Drawer-Container ---------------- */

  function hydrateCrossSell() {
    var slot = document.querySelector('[data-lm-cross-sell]');
    if (!slot || slot.dataset.lmDone) return;
    slot.dataset.lmDone = '1';
    var firstId = slot.dataset.firstProduct;
    if (!firstId) return;
    var inCart = (slot.dataset.cartProducts || '').split(',');
    var colors = (slot.dataset.cartColors || '').split('|').filter(Boolean);

    fetchRecommendations(firstId).then(function (products) {
      var noSets = (products || []).filter(function (p) { return !isSparsetProduct(p); });
      var cards = buildCards(noSets, colors, inCart, 2, true); // compact im Drawer
      if (!cards.length) return;
      slot.innerHTML =
        '<div style="border-top:1px solid rgba(var(--color-base-foreground),0.1);padding-top:12px;margin-top:2px;">' +
          '<div style="font-size:12px;font-weight:600;color:#666;margin-bottom:8px;">Passt perfekt dazu</div>' +
          '<div style="display:flex;flex-direction:column;gap:8px;">' + cards.join('') + '</div>' +
        '</div>';
    });
  }

  /* ---------------- PDP-Container ---------------- */

  var _compCache = {}; // productId -> products[] (Empfehlungen haengen am Produkt,
                       // nicht an der Variante; bei Farbwechsel nur neu rendern)

  function renderComplementary(slot, products) {
    var colors = slot.dataset.color ? [slot.dataset.color] : [];
    var limit = parseInt(slot.dataset.limit, 10) || 3;
    var cards = buildCards(products, colors, [String(slot.dataset.productId)], limit);
    if (!cards.length) { slot.innerHTML = ''; return; }
    var bg = slot.dataset.bg;
    slot.innerHTML =
      '<div style="' + (bg ? 'background:' + bg + ';border-radius:12px;padding:16px;' : '') + '">' +
        '<div class="heading text-base md:text-lg" style="margin-bottom:12px;">' + escapeHtml(slot.dataset.heading || 'Passt perfekt dazu') + '</div>' +
        '<div style="display:flex;flex-direction:column;gap:10px;">' + cards.join('') + '</div>' +
      '</div>';
  }

  function hydrateComplementary() {
    var slot = document.querySelector('[data-lm-complementary]');
    if (!slot) return;
    var productId = slot.dataset.productId;
    if (!productId) return;
    // Pro Farbe nur einmal rendern (verhindert Loop mit dem MutationObserver);
    // bei Farbwechsel setzt onVariantChange data-color neu -> laeuft erneut.
    if (slot.dataset.lmColorDone === (slot.dataset.color || '')) return;
    slot.dataset.lmColorDone = slot.dataset.color || '';

    if (_compCache[productId]) {
      renderComplementary(slot, _compCache[productId]);
    } else {
      fetchRecommendations(productId).then(function (products) {
        _compCache[productId] = products;
        renderComplementary(slot, products);
      });
    }
  }

  // Aktuell gewaehlte Farbe aus dem Varianten-Picker lesen.
  function currentPdpColor() {
    var group = document.querySelector('[data-option-group][data-option-name="farbe"]');
    if (!group) return null;
    var checked = group.querySelector('input[type="radio"]:checked');
    if (checked && checked.value) return checked.value;
    var label = group.querySelector('[data-option-group-selected-value-label]');
    return label ? label.textContent.trim() : null;
  }

  // Essence feuert variant:change auf document; Fallback: change im Farb-Fieldset.
  function onVariantChange() {
    var slot = document.querySelector('[data-lm-complementary]');
    if (!slot) return;
    var col = currentPdpColor();
    if (col != null && col !== slot.dataset.color) {
      slot.dataset.color = col; // hydrateComplementary rendert dann mit neuer Farbe
      hydrateComplementary();
    }
  }

  /* ---------------- Drawer-Refresh ---------------- */

  // #cart-drawer-maincontent existiert nur bei nicht-leerem Warenkorb
  // ({% if cart != empty %} in cart-modal.liquid). War der Warenkorb beim
  // Seitenaufbau leer, muss der komplette [slot=content] getauscht werden —
  // gleicher Fallback wie replaceCartDrawer() in der Section selbst.
  function swapDrawerHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('#cart-drawer-maincontent');
    var cur = document.querySelector('#cart-drawer-maincontent');
    if (next && cur) {
      cur.innerHTML = next.innerHTML; // Observer hydratisiert neu
      return;
    }
    var nextSlot = doc.querySelector('#cart-modal > div[slot="content"]');
    var curSlot = document.querySelector('#cart-modal > div[slot="content"]');
    if (nextSlot && curSlot) curSlot.innerHTML = nextSlot.innerHTML;
  }

  function replaceDrawer() {
    return fetch('/?section_id=cart-modal')
      .then(function (r) { return r.text(); })
      .then(swapDrawerHtml);
  }

  /* ---------------- Gutscheincode-Eingabe ---------------- */

  // Aktions-Codes mit Mindestmenge: bei Ablehnung erklaeren wir, warum der
  // Code (noch) nicht greift, statt der generischen Meldung. Neue Aktionscodes
  // hier ergaenzen (Codes GROSS schreiben).
  var CAMPAIGN_HINTS = [
    // Summer Sale 2026 (SUMMERPRESALE / SUMMERSALE / SOMMER, 20 % ab 2 Artikeln) beendet am 02.09.2026.
    // Beispiel fuer die naechste Aktion: { codes: ['CODE'], minQty: 2 },
  ];

  // Sparsets (Handle sparset-*/Set-Konfigurator bzw. _bundle_id-Property) und
  // Geschenkgutscheine sind von Aktionscodes ausgenommen und zaehlen nicht
  // zur Mindestmenge.
  function countsTowardCampaign(item) {
    if (item.gift_card || item.handle === 'lilimaus-geschenk-gutschein') return false;
    if (item.properties && item.properties._bundle_id) return false;
    if ((item.handle || '').indexOf('sparset-') === 0 || item.handle === 'erstelle-dein-set') return false;
    return true;
  }

  function eligibleQty(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return countsTowardCampaign(item) ? sum + item.quantity : sum;
    }, 0);
  }

  function voucherErrorMessage(code, cart) {
    var upper = code.toUpperCase();
    var campaign = CAMPAIGN_HINTS.find(function (c) { return c.codes.indexOf(upper) !== -1; });
    // Geschenkgutscheine laufen hier immer auf: /discount/ kennt nur Rabattcodes,
    // Shopify nimmt Gutscheine erst im Checkout an (Kundenfall 16.10.2026).
    if (!campaign) return 'Dieser Code ist ungültig oder für deinen Warenkorb nicht einlösbar. Ist es ein Geschenkgutschein? Den löst du im nächsten Schritt an der Kasse ein.';
    var qty = eligibleQty(cart);
    if (qty < campaign.minQty) {
      var missing = campaign.minQty - qty;
      var text = 'Der Code ' + upper + ' gilt ab ' + campaign.minQty + ' Artikeln im Warenkorb – leg noch '
        + (missing === 1 ? '1 Artikel' : missing + ' Artikel')
        + ' dazu, dann wird der Rabatt abgezogen.';
      if (qty < (cart.item_count || 0)) text += ' Sparsets & Geschenkgutscheine zählen dabei nicht mit.';
      return text;
    }
    // Mindestmenge erfuellt, trotzdem abgelehnt: Artikel sind nicht Teil der
    // Aktion (z.B. Sparsets/Gutscheine oder im Rabatt fehlende neue Produkte).
    return 'Der Code ' + upper + ' gilt leider nicht für die Artikel in deinem Warenkorb – Sparsets & Geschenkgutscheine sind von der Aktion ausgenommen.';
  }

  function applyVoucher(input, btn, msg) {
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = '…';
    msg.textContent = '';
    msg.style.color = '';
    // /discount/ setzt das Rabatt-Cookie und wendet den Code auf den Cart an
    // (Shopify Standard: genau 1 Code). redirect=/cart.js haelt die Antwort klein.
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var dc = (cart.discount_codes || []).find(function (d) {
          return (d.code || '').toLowerCase() === code.toLowerCase();
        });
        if (dc && dc.applicable) {
          // Erst evtl. Gratis-Geschenk einlegen (HBXFT5 & Co.), dann Drawer neu
          return syncGiftCodes(true).then(replaceDrawer); // grünes "Code angewendet"-Banner erscheint server-seitig
        }
        msg.textContent = voucherErrorMessage(code, cart);
        msg.style.color = '#b3261e';
        btn.disabled = false;
        btn.textContent = prev;
      })
      .catch(function () {
        msg.textContent = 'Etwas ist schiefgelaufen. Bitte versuch es erneut.';
        msg.style.color = '#b3261e';
        btn.disabled = false;
        btn.textContent = prev;
      });
  }

  /* ---------------- Gratis-Geschenk-Codes ---------------- */

  // Codes, die per Discount-Function "Gift Code Discount" ein Gratis-Geschenk
  // gewaehren (siehe Tools/Shopify-Gift-Code-Discount). Invariante: die
  // Geschenk-Line liegt nur im Warenkorb, solange der Code aktiv ist UND ein
  // Aktionsprodukt drin liegt — sonst raeumen wir sie wieder raus.
  // Numerische IDs (wie /cart.js sie liefert). Neue Codes hier ergaenzen.
  var GIFT_CODES = [
    {
      code: 'HBXFT5',
      productIds: [9928454504747],    // Wimpel- & Sternenkette Musselin
      giftVariantId: 50271841485099,  // 100 Leuchtsterne (7,99 €)
    },
  ];
  var GIFT_PROP = '_lm_gift_code';
  var giftSyncBusy = false;
  var giftSyncLast = 0;

  // Gleicht den Warenkorb mit den Gift-Codes ab. force=true umgeht die
  // Drossel (fuer den Moment direkt nach der Code-Eingabe). Gibt immer ein
  // Promise zurueck; ersetzt Drawer/Badge nur, wenn wirklich etwas geaendert wurde.
  function syncGiftCodes(force) {
    if (giftSyncBusy) return Promise.resolve();
    var now = Date.now();
    if (!force && now - giftSyncLast < 1500) return Promise.resolve();
    giftSyncLast = now;
    giftSyncBusy = true;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var activeCodes = (cart.discount_codes || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return (d.code || '').toUpperCase(); });
        var items = cart.items || [];
        var jobs = [];
        GIFT_CODES.forEach(function (cfg) {
          var active = activeCodes.indexOf(cfg.code) !== -1;
          // Geschenk-Variante schon im Cart? (egal ob manuell oder auto)
          var giftLineAny = items.find(function (it) { return it.variant_id === cfg.giftVariantId; });
          // Von UNS eingelegte Line (Property-Marker) — nur die raeumen wir weg
          var giftLineAuto = items.find(function (it) {
            return it.properties && it.properties[GIFT_PROP] === cfg.code;
          });
          var hasEligible = items.some(function (it) {
            return cfg.productIds.indexOf(it.product_id) !== -1;
          });
          var want = active && hasEligible;
          if (want && !giftLineAny) {
            var props = {};
            props[GIFT_PROP] = cfg.code;
            jobs.push(fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: cfg.giftVariantId, quantity: 1, properties: props }),
            }));
          } else if (!want && giftLineAuto) {
            jobs.push(fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: giftLineAuto.key, quantity: 0 }),
            }));
          }
        });
        if (!jobs.length) return null;
        return Promise.all(jobs).then(function () {
          refreshCartBadge();
          return replaceDrawer();
        });
      })
      .catch(function () {})
      .then(function () { giftSyncBusy = false; });
  }

  /* ---------------- Warenkorb-Add ---------------- */

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var b = document.getElementById('CartBubble');
        if (!b) return;
        b.textContent = c.item_count;
        if (c.item_count > 0) b.classList.remove('hidden');
      })
      .catch(function () {});
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/?section_id=cart-modal');
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        swapDrawerHtml(html);
        btn.textContent = '✓';
        btn.disabled = false;
        refreshCartBadge();
        setTimeout(function () { btn.textContent = prev; }, 2500);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = prev;
      });
  }

  /* ---------------- Wiring ---------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lm-add]');
    if (btn) {
      e.preventDefault();
      addToCart(btn.getAttribute('data-lm-add'), btn);
      return;
    }
    var voucherBtn = e.target.closest && e.target.closest('[data-lm-voucher-apply]');
    if (voucherBtn) {
      e.preventDefault();
      var box = voucherBtn.closest('[data-lm-voucher]');
      applyVoucher(box.querySelector('[data-lm-voucher-input]'), voucherBtn, box.querySelector('[data-lm-voucher-msg]'));
    }
  });

  // Enter im Gutscheinfeld = Einlösen (nicht das Cart-Formular absenden)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-lm-voucher-input]');
    if (!input) return;
    e.preventDefault();
    var box = input.closest('[data-lm-voucher]');
    applyVoucher(input, box.querySelector('[data-lm-voucher-apply]'), box.querySelector('[data-lm-voucher-msg]'));
  });

  // PDP-Empfehlung dem Variantenwechsel folgen lassen (Essence ersetzt den
  // Container nicht selbst -> wir lauschen aktiv auf die Farbwahl).
  document.addEventListener('variant:change', onVariantChange);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-option-group][data-option-name="farbe"]')) {
      setTimeout(onVariantChange, 60);
    }
  }, true);

  var scheduled = null;
  function hydrate() {
    hydrateCrossSell();
    hydrateComplementary();
    // Cart hat sich evtl. geaendert (Drawer-Replace loest den Observer aus):
    // Gift-Codes nachziehen. Gedrosselt; ohne Handlungsbedarf nur 1 GET /cart.js.
    syncGiftCodes(false);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      hydrate();
    });
  }

  function init() {
    hydrate();
    // Drawer UND PDP-Section werden per innerHTML ersetzt (Cart-Update,
    // Variantenwechsel-Morph) -> frische Container erkennen und fuellen.
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
